<script setup>
import Button from './button/Button.vue';
defineProps({
  title: {
    type: String,
    required: true,
  },
  buttons: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['click', 'close']);

const handleButtonClick = button => {
  emit('click', button.key);
};
</script>

<template>
  <div
    class="chatmigo-section-header chatmigo-panel-header flex h-12 items-center justify-between border-b border-n-weak px-4 py-2"
  >
    <div class="flex items-center justify-between gap-2 flex-1">
      <span class="chatmigo-panel-title text-sm font-semibold tracking-tight text-n-slate-12">{{ title }}</span>
      <div class="flex items-center gap-1 rounded-xl border border-n-strong/15 bg-n-surface-1/90 p-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)]">
        <Button
          v-for="button in buttons"
          :key="button.key"
          v-tooltip="button.tooltip"
          :icon="button.icon"
          ghost
          sm
          @click="handleButtonClick(button)"
        />
        <Button
          v-tooltip="$t('GENERAL.CLOSE')"
          icon="i-lucide-x"
          ghost
          sm
          @click="$emit('close')"
        />
      </div>
    </div>
  </div>
</template>
